import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { buildClassName } from 'utils/build-class-name';
import { sortListingsByThumbnail } from 'data/listing';
import ListingCard, { type ListingCardData } from 'components/listing-card/listing-card';
import { WidgetCTACard } from 'components/pages/team/nearby-listings/components/widget-cta-card';
import styles from './style.module.scss';

import type { IUserLocation } from 'utils/user-location';
import type { OnListingCardClickProps } from 'utils/listing-card';

// eslint-disable-next-line react-hooks/rules-of-hooks -- SwiperCore is a global instance
SwiperCore.use([Navigation, Pagination]);

type HomesCarouselProps = {
  listings?: ListingCardData[];
  location: IUserLocation;
  onListingCardClick: (props: OnListingCardClickProps) => void;
};

export default function NearbyHomesCarousel({ listings = [], location, onListingCardClick }: HomesCarouselProps) {
  const spaceBetween = listings ? 15 : 0;

  const buildCarouselItems = () => {
    const items = sortListingsByThumbnail(listings).map((listing, index) => (
      <SwiperSlide virtualIndex={index} key={listing.id} className={styles.slide}>
        <ListingCard listing={listing} isWidget={true} onListingCardClick={onListingCardClick} />
      </SwiperSlide>
    ));

    items.push(
      <SwiperSlide virtualIndex={items.length} key={items.length} className={styles.slide}>
        <WidgetCTACard key={items.length} userLocation={location} />
      </SwiperSlide>
    );

    return items;
  };

  return (
    <div className={styles.component}>
      <Swiper
        className={buildClassName(styles.slider, 'homes-carousel')}
        loop
        navigation
        pagination={{ clickable: true }}
        slidesPerView='auto'
        spaceBetween={spaceBetween}
      >
        {buildCarouselItems()}
      </Swiper>
    </div>
  );
}